import { combineReducers } from "redux";
import { authReducer } from "../modules/auth/reducer";
import { persistentStoreReducer } from "../modules/persistentStore/reducer";
import { messaggioReducer } from "../modules/messaggio/reducer";
import { anagrafeReducer } from "../modules/anagrafe/reducer";
import { profilazioneReducer } from "../modules/profilazione/reducer";
import { screeningReducer } from "../modules/screening/reducer";
import { screeningColonRettoReducer } from "../modules/screeningColonRetto/reducer";
import { screeningMammograficoReducer } from "../modules/screeningMammografico/reducer";
import { postLoginReducer } from "../modules/postLogin/reducer";


const allReducers = {
    auth: authReducer,
    persistentStore: persistentStoreReducer,
    messaggio: messaggioReducer,
    anagrafe: anagrafeReducer,
    profilazione: profilazioneReducer,
    screening: screeningReducer,
    screeningColonRetto: screeningColonRettoReducer,
    screeningMammografico: screeningMammograficoReducer,
    postLogin: postLoginReducer,
}

export const createReducers = () => {
    const appReducers = combineReducers({ ...allReducers });
    return appReducers;
}